import React, { useEffect, useState } from 'react';
import Icon from './Icon';

// Botao flutuante "voltar ao topo". Quem rola e a JANELA (o .main nao tem overflow
// proprio), entao o listener e no window. So aparece depois de rolar um pouco, para
// nao ficar sobrando na tela em pagina curta. O Icon nao tem 'chev-up': usamos o
// 'chev-down' girado 180deg pelo CSS (.pd-voltar-topo svg).
export default function VoltarAoTopo({ limite = 320 }) {
    const [visivel, setVisivel] = useState(false);

    useEffect(() => {
        const aoRolar = () => setVisivel(window.scrollY > limite);
        aoRolar();
        window.addEventListener('scroll', aoRolar, { passive: true });
        return () => window.removeEventListener('scroll', aoRolar);
    }, [limite]);

    if (!visivel) return null;
    return (
        <button
            type="button"
            className="pd-voltar-topo"
            title="Voltar ao topo"
            aria-label="Voltar ao topo da página"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        >
            <Icon name="chev-down" size={16} />
        </button>
    );
}
